<template>
  <div class="five-star-rating">
    <div class="call-to-action">
      Rate This Question
    </div>
    <div class="stars">
      <button
        v-for="(star, index) in displayedStars"
        :key="`star_${index}`"
        class="star"
        @click="submitFiveStarRate(index + 1)"
      >
        <icon
          :name="star ? 'star-filled' : 'star'"
        ></icon>
      </button>
    </div>
    <div
      class="feedback"
      :class="{ shown: fiveStarRating == 1 || fiveStarRating == 2 }"
    >
      <a :href="`mailto:support@hltcorp.com?subject=${subject}&body=${message}`">
        How could it improve?
      </a>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';
import RatingMixin from '@/mixins/rating';

export default {
  components: {
    Icon,
  },
  mixins: [RatingMixin],
  props: {
    asset: {
      type: Object,
      default: () => {},
    },
    category: {
      type: Object,
      default: () => {},
    },
    rateableType: {
      type: String,
    },
  },
  computed: {
    displayedStars() {
      const stars = [];
      for (let i = 0; i < 5; i++) {
        stars.push(i < this.fiveStarRating);
      }
      return stars;
    },
    message() {
      return `${encodeURIComponent(this.assetType)} ID: ${encodeURIComponent(this.asset.id)}%0D%0A` +
        `Link: ${encodeURIComponent(window.location.href)}%0D%0A%0D%0A` +
        'How can we improve this question?%0D%0A%0D%0A';
},

    rateableId() {
      return this.asset?.id;
    },
    subject() {
      return this.$store.getters['app/appName'];
    },
    assetType() {
      if (this.rateableType === 'V3Flashcard') {
        return 'Question';
      } else {
        return this.rateableType;
      }
    },
  },
  created() {
    this.$watch('ratingKey', () => {
      this.$store.dispatch('ratings/fetch', { id: this.rateableId, type: this.rateableType });
    }, { immediate: true });
  },
  methods: {
    submitFiveStarRate(rating) {

      const eventParams = {
        'Asset ID': this.asset.id,
        'Asset Title': this.ratedAssetTitle(this.rateableId),
        'Asset Type': this.rateableType,
        'Category ID': this.category?.id,
        'Category Name': this.category?.name,
      };

      this.$analytics.events.ratedAsset({
        ...eventParams,
        'Rated': `${rating} stars`,
      });

      const params = {
        rating: rating,
        ratingType: 'fivestar',
        rateableId: this.rateableId,
        rateableType: this.rateableType,
      };

      return this.$store.dispatch('ratings/create', params);
    },

  },
};
</script>

<style lang="scss" scoped>
.five-star-rating {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1rem auto;

  .call-to-action, .feedback {
    font-size: rem-calc(14);
    font-weight: 600;
    line-height: rem-calc(25);

    a {
      text-decoration: underline;
    }
  }

  .star {
    background: transparent;
    margin: 0 rem-calc(4);
    padding: 0;
  }

  .feedback {
    margin-top: rem-calc(8);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.8s ease-in-out;
    &.shown {
      opacity: 1;
      visibility: visible;
    }
  }
}
</style>
